import student from './student';
import teacher from './teacher';
import studentExcel from './studentExcel';
import teacherExcel from './teacherExcel';

export default {
    student,
    teacher,
    studentExcel,
    teacherExcel
}